import React, { useState } from "react";
import styles from "./PreviewRating.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { setSelectedOptionsForFormula } from "@redux/slices/scoringSlice";
import { useDispatch } from "react-redux";

const PreviewRating = (props) => {
  const dispatch = useDispatch();
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [value, setValue] = useState(0);

  const minValue = props?.data?.options[0] || 1; // Get min value from props
  const maxValue = props?.data?.options[1] || 10; // Get max value from props
  const handleRange = (e) => {
    setValue(e.target.value);
    dispatch(
      setSelectedOptionsForFormula({ id: props.id || props?._id, value: Number(e.target.value) })
    );
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {" "}
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.sliderContainer}>
          <input
            type="range"
            min={minValue}
            max={maxValue}
            value={value}
            onChange={(e) => handleRange(e)}
            className={styles.slider}
          />
          <div className={styles.sliderValue}>{value}</div>
        </div>
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewRating;
